import React, { useCallback, useMemo } from "react";
import * as R from "ramda";
import { Query } from "react-apollo";
import { Link } from "react-router-dom";
import { Tunnel, TunnelPlaceholder } from "react-tunnels";

import Button from "@arachnys/styleguide/Button";
import Tabs from "@arachnys/styleguide/Tabs";
import { withApolloState } from "@arachnys/flow-app/src/util/apollo";
import RequestsTable from "./Search";
import { GET_BULK_PERMISSIONS } from "./queries";
import BulkUploadsTable from "./BulkUploads";

const tabs = [
    {
        label: "Requests",
        content: <RequestsTable />,
        key: "requests",
    },
    {
        label: "Batch Requests",
        content: <BulkUploadsTable />,
        key: "bulk",
    },
];

const TicketsPage = ({ history, location: { pathname } }) => {
    const changeTab = useCallback(
        key => {
            history.push(`/tickets/${key}/`);
        },
        [history]
    );

    // /tickets/search/ will return "search"
    const location = useMemo(
        () => R.pathOr("requests", [1], pathname.match(/.*tickets\/(.*)\/$/)),
        [pathname]
    );

    return (
        // add permissions data to apollo cache
        <Query query={GET_BULK_PERMISSIONS} fetchPolicy="network-only">
            {withApolloState(() => (
                <>
                    <Tunnel id="bluebar-right-content">
                        <TunnelPlaceholder id="create-bulk-request" />
                        <Link to="/tickets/create/">
                            <Button.Ghost size="large">
                                Create new Request
                            </Button.Ghost>
                        </Link>
                    </Tunnel>
                    <Tabs
                        tabs={tabs}
                        onChange={changeTab}
                        activeKey={location}
                    />
                </>
            ))}
        </Query>
    );
};

export default TicketsPage;
